/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./BaseToggle.vue?vue&type=template&id=a2ed1f7a&scoped=true"
import script from "./BaseToggle.vue?vue&type=script&lang=js"
export * from "./BaseToggle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2ed1f7a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686490483/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a2ed1f7a')) {
      api.createRecord('a2ed1f7a', component.options)
    } else {
      api.reload('a2ed1f7a', component.options)
    }
    module.hot.accept("./BaseToggle.vue?vue&type=template&id=a2ed1f7a&scoped=true", function () {
      api.rerender('a2ed1f7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/base/BaseToggle.vue"
export default component.exports